<div class="imageGallery__closeButton" *ngIf="isOpen">
  <app-ds-button-icon
    [icon]="icon.Close"
    [buttonSize]="buttonSize.LG"
    (clickEvent)="toggleOpen()"></app-ds-button-icon>
</div>

<div class="imageGallery__mainCont" #mainImage [class.open]="isOpen">
  <app-ds-draggable-touch-carousel
    [draggable]="true"
    [images]="imagesOnCarousel"
    [height]="'200px'"
    [borderRadius]="'var(--border-radius-none) var(--border-radius-none) var(--border-radius-mini) var(--border-radius-mini)'"
    [draggable]="true"
    (currentSlideValue)="setCurrentSlide($event)"
  >
    <div class="imageGallery__carouselOverlay" *ngIf="showOverlay">
      <app-ds-typography
        (click)="toggleOpen()"
        [size]="fontSize.RG"
        [color]="fontColor.Invert"
        [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.VIEW_GALLERY' | transloco">
      </app-ds-typography>
      <app-ds-icon
        (click)="toggleOpen()" [icon]="icon.ChevronDown" [color]="iconColor.Light" [size]="18">
      </app-ds-icon>
    </div>
  </app-ds-draggable-touch-carousel>

  <div class="imageGallery__viewAll" [class.open]="isOpen">
    <ul class="all-images" #allImages>
      <ng-container *ngFor="let image of images; index as i; trackBy: trackById">
        <li>
          <app-ds-image
            [src]="image"
            [width]="imageWidth(i)"
            [height]="imageHeight(i)"
            [size]="imageSize">
          </app-ds-image>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="imageGallery__goToTop"
    *ngIf="isOpen">
    <app-ds-button-icon
      [icon]="icon.ChevronUp"
      [buttonSize]="buttonSize.LG"
      (clickEvent)="scrollTop()">
    </app-ds-button-icon>
  </div>

</div>
